import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
import { getSystemSettings } from "../state/systemSettingsSlice";
export function GetSystemSettings(dispatch) {
  axios.get(`${Globals.baseUrl}/SystemSettings/GetSystemSettings`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(getSystemSettings(res.data));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetSystemSettings2() {
  axios.get(`${Globals.baseUrl}/SystemSettings/GetSystemSettings`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SystemGetSettings,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateSystemSettings(settings) {
  axios.post(`${Globals.baseUrl}/SystemSettings/UpdateSystemSettings`, settings, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SystemUpdateSettings,
        Result: res.data
      });
      PostAlert("success", "System settings updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
